/**
 * 接口
 */
const getAnnualReport = {
    url: `/uds/in/fellow/v4/fellow/annual-report`,
    method: 'get'
};

const getKeywordScreenshot = {
    url: `/report/screenshot/keyword`,
    method: 'get',
    requstTypeJson: true,
    serverHost: '/backend'
};

export default {
    getAnnualReport,
    getKeywordScreenshot
};



// WEBPACK FOOTER //
// ./src/service/report/index.js